// EXTERNAL DEPENDENCIES
import React from 'react'

// HELPERS
import { invokeOnSpaceOrEnter } from '@/utils'

// COMPONENTS
import { CameraIcon } from '@paypalcorp/pp-react'

// TEST IDS
import { PROFILE_PHOTO_IMAGE_OVERLAY_TEST_ID } from '@/constants/test-ids'

// STYLES
import styles from './styles.module.less'

/**
 * Circular photo overlay meant to indicate that
 * the photo is editable
 */
export function ProfilePhotoOverlay({
  handleClick,
}: {
  handleClick: () => void
}) {
  return (
    <div
      role='button'
      tabIndex={0}
      onClick={handleClick}
      aria-haspopup={!!handleClick}
      className={styles.profilePhotoOverlayContainer}
      onKeyDown={invokeOnSpaceOrEnter(handleClick)}
      data-testid={PROFILE_PHOTO_IMAGE_OVERLAY_TEST_ID}
    >
      <div className={styles.profilePhotoOverlay}>
        <CameraIcon
          className={styles.profilePhotoCameraIcon}
          color='sysColorBackgroundSurface'
        />
      </div>
    </div>
  )
}
